import { Button } from "components/DesignSystem/Button/Button";
import { ReactNode } from "react";
import { useDispatch } from "react-redux";
import { openRequestDocumentsModal } from "store/slices/requestDocumentsInChat";

type DocumentRequested = {
  uuid: string;
  type: string;
  is_uploaded: string;
};

type CustomData = {
  header: string;
  metadata: {
    document_request_id: string;
    requested_documents: DocumentRequested[];
  };
};

export const RequestDocumentCTA = ({
  channelId,
  customData,
  groupId,
  completed,
}: {
  customData: CustomData;
  channelId: string;
  groupId: string;
  completed?: boolean;
}) => {
  const { requested_documents, document_request_id } = customData.metadata;

  const dispatch = useDispatch();

  const onUploadClick = () =>
    dispatch(
      openRequestDocumentsModal({
        isModalOpen: true,
        channelId: channelId,
        groupId: groupId,
        documentsRequest: requested_documents,
        requestId: document_request_id,
      })
    );

  const allDocumentsAreUploaded =
    requested_documents.every((d) => d.is_uploaded) || completed;

  return (
    <div>
      <Button block onClick={onUploadClick} size="small">
        {allDocumentsAreUploaded ? "View" : "Upload"}
      </Button>
    </div>
  );
};
